/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import moment from "moment";
import "moment-timezone";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Collapse, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Images from "../../Api/Images";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import Master from "../../assets/image/Master.svg";
import NotVerified from "../../assets/image/NotVerified.svg";
import RightDown from "../../assets/image/RightDown.svg";
import UserNotFound from "../../assets/image/UserNotFound.svg";
import Verified from "../../assets/image/Verified.svg";
import Visa from "../../assets/image/Visa.svg";
import cross_for_viewcard from "../../assets/image/cross_for_viewcard.svg";
import { ClearFormSetFutios } from "../../redux/actions/adminAction";
import CommonewModel from "../commonModel/commonModel";
import ReusableTable from "./ReusableTable";
import InputField from "../RecipientManagement/InputField";
import { useForm, useWatch } from "react-hook-form";
import AddM from "../../assets/image/AddM.svg";
import { toast } from "react-toastify";

const UserManagement = () => {
  const { websocket } = useContext(WebSocketContext);
  const {
    userList,
    search,
    listStatus,
    ClearFormSet,
    machineList,
    assignCreditDetails,
  } = useSelector((state) => state.adminReducers);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const [activeTableDetails, setActiveTableDetails] = useState("");
  const [viewModal, setViewModel] = useState({
    open: false,
    data: null,
  });
  const handleOpen = (data) => {
    setViewModel({ open: true, data });
  };
  const handleClose = () => {
    setViewModel({ open: false, data: null });
  };

  const [showModalNew, setShowModalNew] = useState({
    open: false,
    title: "",
    modalType: "",
    Data: {},
  });
  const [rows, setRows] = useState([]);
  const [newAmount, setNewAmount] = useState("");
  const [showManageModal, setShowManageModal] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  const [machineInput, setMachineInput] = useState("");
  const [filtered, setFiltered] = useState([]);
  const dropdownRef = useRef(null);
  const [localSearch, setLocalSearch] = useState("");
  const {
    register,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const searchValue = useWatch({
    control,
    name: "MachineID",
  });

  const currentFunction = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (currentPage < 1) return;
    setCurrentPage(currentPage);
  }, [currentPage]);

  useEffect(() => {
    callUserList();
  }, [websocket, currentPage, search, listStatus]);

  useEffect(() => {
    callUserList();
  }, []);

  function callUserList() {
    let param = {
      transmit: "single",
      url: "user_list",
      request: {
        status:
          listStatus === undefined || listStatus === ""
            ? ""
            : parseInt(listStatus),
        limit: "20",
        page_no: search ? 1 : currentPage,
        search: search ? search : "",
        order_by: "-updated_at",
        user_type: "user",
      },
    };
    wsSend_request(websocket, param);
  }
  function handleSwitchChange(id, isChecked) {
    let param = {
      transmit: "single",
      url: "user_status_update",
      request: {
        status: isChecked,
        user_id: id,
      },
    };
    wsSend_request(websocket, param);
  }

  useEffect(() => {
    if (
      ClearFormSet?.url === "user_status_update" &&
      ClearFormSet?.action === 200
    ) {
      callUserList();
    }
    setTimeout(() => {
      dispatch(
        ClearFormSetFutios({
          url: "",
          action: "",
        }),
      );
    }, 1000);
  }, [ClearFormSet, dispatch]);

  const openModal = (Amt, user_id, status) => {
    setShowModalNew({
      ...showModalNew,
      open: !showModalNew?.open,
      title: "Create New Box",
      subtitle: "Create New Model",
      modalType: status,
      Data: { Amt: Amt, user_id: user_id },
    });
    const paylod = {
      transmit: "single",
      url: "assign_credit_details",
      request: {
        user_id: user_id,
      },
    };
    wsSend_request(websocket, paylod);
  };

  const ViewMoreDetails = (id) => {
    setActiveTableDetails(id);
  };

  const ElseMoreDetails = () => {
    setActiveTableDetails("");
  };
  const headers = [
    { name: "", key: "" },
    { name: "User Id", key: "user_id" },
    { name: "Profile", key: "profile" },
    { name: "Full Name", key: "username" },
    { name: "Mobile Number", key: "phone" },
    { name: "Email Address", key: "email" },
    { name: "Verification", key: "verification" },
    { name: "Status", key: "status" },
    { name: "My Balance", key: "my_balance" },
    { name: "Withdraw Unutilized", key: "refund_utlize" },
    { name: "Assign Credit", key: "assignCredit" },
  ];
  const cardList = [
    {
      cardNo: "**** **** **** 1234",
      expDate: "08/26",
      brand: "visa",
    },
    {
      cardNo: "**** **** **** 5678",
      expDate: "09/27",
      brand: "master_Card",
    },
    {
      cardNo: "**** **** **** 9876",
      expDate: "12/28",
      brand: "visa",
    },
  ];

  const renderRow = (user, index, visibleColumns) => {
    return (
      <React.Fragment key={user.id}>
        <tr className="user-management-table-detail">
          <td>
            <div
              style={{ height: "15px", width: "10px", cursor: "pointer" }}
              onClick={() =>
                activeTableDetails === user.id
                  ? ElseMoreDetails()
                  : ViewMoreDetails(user.id)
              }
            >
              <img
                src={RightDown}
                style={{
                  objectFit: "contain",
                  height: "100%",
                  width: "100%",
                  transform:
                    activeTableDetails === user.id
                      ? "rotate(90deg)"
                      : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                }}
                alt="down"
              />
            </div>
          </td>
          {visibleColumns?.includes("user_id") && (
            <td className="Vertical_align">{user.user_code || "-"}</td>
          )}
          {visibleColumns?.includes("profile") && (
            <td className="Vertical_align">
              <div>
                {user.avatar ? (
                  <Images
                    src={user?.avatar}
                    height={20}
                    width={20}
                    alt="Avatar"
                  />
                ) : (
                  <div style={{ width: "20px", height: "20px" }}>
                    <img src={UserNotFound} className="w-100" />
                  </div>
                )}
              </div>
            </td>
          )}
          {visibleColumns?.includes("username") && (
            <td className="Vertical_align">{user.username || "-"}</td>
          )}
          {visibleColumns?.includes("phone") && (
            <td className="Vertical_align">{user.phone || "-"}</td>
          )}
          {visibleColumns?.includes("email") && (
            <td className="Vertical_align">{user.email || "-"}</td>
          )}
          {visibleColumns?.includes("verification") && (
            <td className="Vertical_align">
              <div
                style={{
                  height: "24px",
                  color: "black",
                  background: user.is_verified ? "#B6EFBB" : "#F7ABAB",
                  borderRadius: "4px",
                  padding: "5px",
                  textAlign: "center",
                }}
              >
                {user.is_verified ? "Verified" : "Not Verified"}
              </div>
            </td>
          )}
          {visibleColumns?.includes("status") && (
            <td className="Vertical_align">
              <Form.Check
                type="switch"
                id={`switch-${user.id}`}
                defaultChecked={user.is_active}
                className=""
                onChange={(e) => handleSwitchChange(user.id, e.target.checked)}
              />
            </td>
          )}
          {visibleColumns?.includes("my_balance") && (
            <td className="Vertical_align">{user.user_balance || "-"}</td>
          )}
          {visibleColumns?.includes("refund_utlize") && (
            <td className="Vertical_align">
              {user.user_balance}
              {user.user_balance && user.user_balance_expire_date && " || "}
              {user.user_balance_expire_date
                ? moment(user.user_balance_expire_date).format("DD-MM-YYYY")
                : ""}
            </td>
          )}

          {visibleColumns.includes("assignCredit") && (
            <td
              title="Assign Credit"
              className="Vertical_align"
              style={{
                color: "#1AA773",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() =>
                openModal(user.user_balance, user.id, "Assign Credit")
              }
            >
              RM {parseFloat(user.user_balance).toFixed(2)}
            </td>
          )}
        </tr>
        <Collapse in={activeTableDetails === user.id}>
          <tr className="tablecollapsewraps" id={`collapse-${user.id}`}>
            <td colSpan={headers.length}>
              <div className="bg-light p-3 rounded" style={{ width: "100%" }}>
                <div className="bg-white rounded d-flex flex-wrap justify-content-between align-items-start gap-3">
                  <div
                    className="d-flex flex-column p-3"
                    style={{
                      minWidth: "150px",
                      height: "132px",
                      flex: 1,
                      borderRight: "2px solid #DCE3EC",
                    }}
                  >
                    <p className="fw-semibold mb-2 subdropdown_title">
                      Document
                    </p>
                    <div className="d-flex gap-2">
                      <Images
                        src={user?.document_front}
                        height={56}
                        width={100}
                        alt="Back"
                      />
                      <Images
                        src={user?.document_back}
                        height={56}
                        width={100}
                        alt="Back"
                      />
                    </div>
                  </div>

                  <div
                    className="d-flex flex-column p-3"
                    style={{
                      minWidth: "150px",
                      height: "132px",
                      flex: 1,
                      borderRight: "2px solid #DCE3EC",
                    }}
                  >
                    {user?.friend_number1 ? (
                      <>
                        <p className="fw-semibold mb-2 subdropdown_title">
                          Friend 1 Mobile Number
                        </p>
                        <span className="number_title">
                          {user?.friend_number1}{" "}
                          <span
                            style={{
                              color: user?.friend_number1_verified
                                ? "#2CBC87"
                                : "#E55757",
                            }}
                          >
                            <img
                              src={
                                user?.friend_number1_verified
                                  ? Verified
                                  : NotVerified
                              }
                              alt="Verified"
                            />{" "}
                            {user?.friend_number1_verified
                              ? "Verified"
                              : "Not Verified"}
                          </span>
                        </span>
                      </>
                    ) : (
                      <p className="fw-semibold mb-2 subdropdown_title">
                        Friend 1 Mobile Number Not Found
                      </p>
                    )}
                  </div>
                  <div
                    className="d-flex flex-column p-3"
                    style={{
                      minWidth: "150px",
                      height: "132px",
                      flex: 1,
                      borderRight: "2px solid #DCE3EC",
                    }}
                  >
                    {user?.friend_number2 ? (
                      <>
                        <p className="fw-semibold mb-2 subdropdown_title">
                          Friend 2 Mobile Number
                        </p>
                        <span className="number_title">
                          {user?.friend_number2}{" "}
                          <span
                            style={{
                              color: user?.friend_number2_verified
                                ? "#2CBC87"
                                : "#E55757",
                            }}
                          >
                            <img
                              src={
                                user?.friend_number2_verified
                                  ? Verified
                                  : NotVerified
                              }
                              alt="Not Verified"
                            />{" "}
                            {user?.friend_number2_verified
                              ? "Verified"
                              : "Not Verified"}
                          </span>
                        </span>
                      </>
                    ) : (
                      <p className="fw-semibold mb-2 subdropdown_title">
                        Friend 2 Mobile Number Not Found
                      </p>
                    )}
                  </div>

                  <div
                    className="d-flex flex-column p-3"
                    style={{ minWidth: "250px", height: "132px", flex: 2 }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="fw-semibold mb-2 subdropdown_title">
                        Linked Cards
                      </p>
                      <h6
                        className="view_title"
                        onClick={() => handleOpen(user)}
                      >
                        View All
                      </h6>
                    </div>
                    <div
                      className="d-flex justify-content-between align-items-center bg-light p-2 rounded mb-2"
                      style={{ height: "40px" }}
                    >
                      <span className="card_title">
                        Card No: **** **** **** 1234
                      </span>
                      <span className="exp_title">Exp Date: 08/26</span>
                      <img src={Visa} alt="Visa" style={{ width: "40px" }} />
                    </div>
                    <div
                      className="d-flex justify-content-between align-items-center bg-light p-2 rounded"
                      style={{ height: "40px" }}
                    >
                      <span className="card_title">
                        Card No: **** **** **** 1234
                      </span>
                      <span className="exp_title">Exp Date: 08/26</span>
                      <img
                        src={Master}
                        alt="Mastercard"
                        style={{ width: "40px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </Collapse>
      </React.Fragment>
    );
  };

  useEffect(() => {
    if (ClearFormSet?.url === "assign_credit" && ClearFormSet?.action === 200) {
      callUserList();
      setShowModalNew({ ...showModalNew, open: false });
    }
    setTimeout(() => {
      dispatch(
        ClearFormSetFutios({
          url: "",
          action: "",
        }),
      );
    }, 1000);
  }, [ClearFormSet, dispatch]);

  useEffect(() => {
    if (searchValue?.length > 0) {
      const payload = {
        transmit: "single",
        url: "machine_list",
        request: {
          status: true,
          limit: "20",
          page_no: "1",
          search: "",
          acquirer_merchant_name: searchValue,
          order_by: "-updated_at",
        },
      };
      wsSend_request(websocket, payload);
    } else {
      setFiltered([]);
    }
  }, [searchValue]);

  useEffect(() => {
    if (searchValue?.length > 0) {
      const machineListForFilter = machineList?.list
        ?.filter((item) => item?.id && item?.machine_name && item?.machine_code)
        ?.map((item) => ({
          id: item?.id,
          name: item?.machine_name,
          code: item?.machine_code,
          acquirer_merchant_name: item?.acquirer_merchant_name,
        }));

      setFiltered(machineListForFilter);
    }
  }, [machineList]);

  const handleAmountChange = (id, value) => {
    setRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, amount: value } : row)),
    );
  };

  const handleAddRow = () => {
    if (!newAmount) {
      toast.error(`Amount is required`);
      return null;
    }

    const amt = parseFloat(newAmount);

    setRows([
      ...rows,
      {
        id: Date.now(),
        previous_credit: 0,
        credit: amt,
        amount: amt.toString(),
        machines: [],
        isNew: true,
      },
    ]);

    setNewAmount("");
  };
  const openManage = (row) => {
    setActiveRow(row);
    setShowManageModal(true);
    reset({ MachineID: "" });
    setFiltered([]);
    setLocalSearch("");
  };

  const addMachine = () => {
    if (!machineInput) return;

    setRows((prev) =>
      prev.map((row) =>
        row.id === activeRow.id
          ? { ...row, machines: [...row.machines, machineInput] }
          : row,
      ),
    );

    setMachineInput("");
  };

  const removeMachine = (index) => {
    setRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id === activeRow.id) {
          const updatedMachines = row.machines.filter((_, i) => i !== index);
          setActiveRow({ ...row, machines: updatedMachines });
          return { ...row, machines: updatedMachines };
        }
        return row;
      }),
    );
  };

  const handleAddMachine = (machine) => {
    setActiveRow((prev) => {
      const exists = prev.machines.some((m) => m.id === machine.id);
      if (exists) return prev;

      const updatedRow = {
        ...prev,
        machines: [...prev.machines, machine],
      };

      // 🔥 Sync with rows state
      setRows((prevRows) =>
        prevRows.map((row) => (row.id === prev.id ? updatedRow : row)),
      );

      return updatedRow;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setFiltered([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSubmitAssignCredit = () => {
    if (!rows.length) return;
    let hasError = false;

    const requestArray = rows
      .map((row, index) => {
        console.log("row", row);
        const previous = parseFloat(row.previous_credit ?? row.credit ?? 0);
        const amount = parseFloat(row.amount || 0);
        const isDebit = row.amount.startsWith("-");

        const machines = row.machines || [];

        if (row.credit === 0) {
          toast.error(`Amount is required`);
          hasError = true;
          return null;
        }

        if (!machines.length) {
          toast.error(`Please select at least one machine`);
          hasError = true;
          return null;
        }

        return {
          user_id: showModalNew?.Data?.user_id,
          trn_type: isDebit ? "debit_order" : "credit_order",
          transaction_type: "wallet",
          amount: amount.toString(),
          previous_credits: previous,
          current_credits: previous + amount,
          acquirer_merchant_name: row.machines[0]?.acquirer_merchant_name,
          machine_list: row.machines?.length
            ? row.machines.map((m) =>
                typeof m === "string"
                  ? {
                      id: m,
                      name: "",
                      code: "",
                      acquirer_merchant_name: "",
                    }
                  : {
                      id: m.id,
                      name: m.name,
                      code: m.code,
                      acquirer_merchant_name: m.acquirer_merchant_name,
                    },
              )
            : [],
        };
      })
      .filter(Boolean);

    if (hasError) return;

    if (!requestArray.length) return;

    const payload = {
      transmit: "single",
      url: "assign_credit",
      request: requestArray,
    };
    wsSend_request(websocket, payload);
  };

  useEffect(() => {
    if (assignCreditDetails?.transactions?.length > 0) {
      const formattedRows = assignCreditDetails.transactions.map((txn) => ({
        id: txn.transaction_id,
        credit: parseFloat(txn.current_credits || 0),
        amount: "",
        machines:
          txn.machine_list?.map((m) => ({
            id: m.id,
            code: m.code,
            name: m.name,
            acquirer_merchant_name: m.acquirer_merchant_name,
          })) || [],
        isExisting: true,
      }));

      setRows(formattedRows);
    } else {
      setRows([]);
    }
  }, [assignCreditDetails]);

  const currentRow = rows.find((r) => r.id === activeRow?.id);

  const filteredMachines = !localSearch
    ? currentRow?.machines || []
    : currentRow?.machines?.filter((m) => {
        const code = (m.code || m).toLowerCase();
        return (
          code.includes(localSearch.toLowerCase()) 
        );
      });

  return (
    <>
      <ReusableTable
        headers={headers}
        data={userList?.list || []}
        height="150px"
        paginationObject={userList?.pagination}
        renderRow={renderRow}
        filters={{
          fromDate: false,
          toDate: false,
          period: false,
          search: true,
          searchPlaceholder: "Search by Full Name, User ID, Email, Mobile No",
          userSelect: false,
          userOptions: [],
          userActive: false,
          userOptionsForActive: [
            { label: "All", value: "" },
            { label: "Active", value: "1" },
            { label: "Inactive", value: "0" },
          ],
          reset: false,
          export: true,
        }}
        currentPage={currentPage}
        handlePageChange={currentFunction}
      />
      {showModalNew?.open && (
        // <CommonewModel
        //   setShowModalNew={setShowModalNew}
        //   showModalNew={showModalNew}
        // />
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content rounded-4"
              style={{
                width: "490px",
                margin: "auto",
                borderRadius: "17px",
                border: "none",
                boxShadow: "1px 1px 1px 0px #ffffff",
                background: "#ffffff",
                padding: "25px",
              }}
            >
              {/* Header */}
              <h5 style={{ fontWeight: "700" }}>Assign Credit</h5>
              <hr />

              {/* Balance */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px 10px",
                  background: "#efefef",
                  marginBottom: "10px",
                  borderRadius: "3px",
                }}
              >
                <span style={{ color: "#000000", fontWeight: "600" }}>
                  Balance: {assignCreditDetails?.current_balance}
                </span>
                <span
                  className="status_refund mb-2"
                  style={{ color: "#717171" }}
                >
                  Credit can be added or deducted{" "}
                </span>
              </div>

              {/* Table Header */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "0.3fr 1fr 1.5fr 1fr",
                  fontWeight: "600",
                  marginBottom: "10px",
                  // alignItems: "center",
                }}
              >
                <span></span>
                <span>Credit</span>
                <span>
                  Assign Credit <br />
                  <span
                    style={{
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "#717171",
                    }}
                  >
                    (eg. +10 or -10)
                  </span>
                </span>
                <div style={{ textAlign: "center" }}>Manage Machine ID</div>
              </div>

              {/* Static Rows (replace with dynamic later if needed) */}
              {rows.map((row, index) => (
                <div
                  key={row.id}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "0.3fr 1fr 1.5fr 1fr",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <span>{index + 1}.</span>

                  <span>{row.credit.toFixed(2)}</span>

                  <input
                    type="number"
                    placeholder="Enter Amount"
                    className="form-control"
                    style={{ width: "100%" }}
                    value={row.amount}
                    onChange={(e) => handleAmountChange(row.id, e.target.value)}
                  />

                  <div style={{ textAlign: "center" }}>
                    <span
                      onClick={() => openManage(row)}
                      style={{
                        color: "#1db997",
                        cursor: "pointer",
                        fontSize: "14px",
                        textDecoration: "underline",
                      }}
                    >
                      Manage
                    </span>
                  </div>
                </div>
              ))}

              {/* Add New Row */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "0.3fr 1fr 1.5fr 1fr",
                  alignItems: "center",
                  marginTop: "15px",
                }}
              >
                <span></span>
                <span>Add New</span>

                <input
                  type="number"
                  placeholder="Enter Amount"
                  className="form-control"
                  style={{ width: "100%" }}
                  value={newAmount}
                  onChange={(e) => setNewAmount(e.target.value)}
                />

                <div style={{ textAlign: "center" }}>
                  <button
                    onClick={handleAddRow}
                    style={{
                      background: "#A5D6A7",
                      border: "none",
                      padding: "10px 17px",
                      borderRadius: "4px",
                      fontSize: "13px",
                      fontWeight: "600",
                    }}
                  >
                    +Add
                  </button>
                </div>
              </div>

              {/* Footer */}
              <div className="d-flex justify-content-end mt-4">
                <button
                  className="me-2"
                  style={{
                    border: "1px solid #a8a6a6",
                    background: "#fff",
                    padding: "6px 14px",
                    borderRadius: "6px",
                  }}
                  onClick={() =>
                    setShowModalNew((prev) => ({ ...prev, open: false }))
                  }
                >
                  Cancel
                </button>

                <button
                  style={{
                    background: "#000",
                    color: "#fff",
                    padding: "6px 20px",
                    borderRadius: "6px",
                    border: "none",
                  }}
                  onClick={handleSubmitAssignCredit}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showManageModal && (
        <div className="modal d-block">
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                width: "350px",
                margin: "auto",
                padding: "20px",
                borderRadius: "12px",
              }}
            >
              <h6 style={{ fontWeight: "700" }}>Manage Machine ID</h6>

              {/* Search */}
              <input
                type="text"
                placeholder="Search Machine ID"
                className="form-control my-3 "
                value={localSearch}
                onChange={(e) => setLocalSearch(e.target.value)}
              />

              {/* Machine List */}
              <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                {filteredMachines?.length > 0 ? (
                  filteredMachines.map((m, i) => (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "6px",
                      }}
                    >
                      <span>
                        {i + 1}. {m.code}
                      </span>

                      <span
                        onClick={() => removeMachine(i)}
                        style={{
                          color: "red",
                          cursor: "pointer",
                          textDecoration: "underline",
                          marginRight: "10px",
                        }}
                      >
                        Remove
                      </span>
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: "center", color: "#888" }}>
                    No matching machines
                  </div>
                )}
              </div>

              {/* Add Machine */}
              <div
                ref={dropdownRef}
                className="col-md-12"
                style={{ position: "relative" }}
              >
                <InputField
                  label=""
                  name="MachineID"
                  register={register}
                  errors={errors}
                  placeholder="Search Machine ID"
                  isSearchIcon={true}
                  isHeight={false}
                />

                <div className="search-machine">
                  {filtered?.length > 0 && (
                    <div
                      className="result-list"
                      style={{
                        maxHeight: "180px",
                        overflowY: "auto",
                        position: "absolute",
                        width: "100%",
                        borderTop: "none",
                        borderRight: "1px solid rgb(223, 223, 223)",
                        borderBottom: "1px solid rgb(223, 223, 223)",
                        borderLeft: "1px solid rgb(223, 223, 223)",
                        borderImage: "initial",
                        marginTop: "-13px",
                        borderRadius: "0 0 5px 5px",
                        top: "68px",
                        zIndex: "999",
                        background: "white",
                      }}
                    >
                      {filtered.map((machine, index) => (
                        <div
                          key={machine?.id}
                          className="d-flex justify-content-between align-items-center p-2"
                          style={{
                            borderBottom:
                              index !== filtered.length - 1
                                ? "1px solid #ECECEC"
                                : "none",
                            background: "#fff",
                          }}
                        >
                          {/* LEFT SIDE */}
                          <div className="d-flex align-items-center gap-2">
                            <div
                              style={{
                                width: 36,
                                height: 36,
                                background: "#DCEDE4",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img src={AddM} alt="icon" />
                            </div>

                            <div>
                              <div style={{ fontWeight: "600" }}>
                                {machine?.name}
                              </div>
                              <div style={{ fontSize: "12px", color: "#888" }}>
                                {machine?.code}
                              </div>
                            </div>
                          </div>

                          {/* ADD BUTTON */}
                          <button
                            onClick={() => handleAddMachine(machine)}
                            style={{
                              background: "#B6EFBB",
                              border: "none",
                              padding: "5px 10px",
                              borderRadius: "4px",
                              fontWeight: "600",
                              fontSize: "12px",
                            }}
                          >
                            + Add
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Done */}
              <button
                onClick={() => setShowManageModal(false)}
                style={{
                  marginTop: "15px",
                  width: "100%",
                  background: "#000",
                  color: "#fff",
                  padding: "8px",
                  borderRadius: "6px",
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
      {viewModal?.open && (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content rounded-4"
              style={{
                width: "430px",
                margin: "auto",
                borderRadius: "17px",
                border: "none",
                boxShadow: "1px 1px 1px 0px #ffffff",
                background: "#F7F8FC",
                padding: "25px",
              }}
            >
              <div className="text-start">
                <div className="d-flex justify-content-between align-items-center">
                  <h1 className="view_popup_title">Card Details</h1>
                  <img
                    src={cross_for_viewcard}
                    alt="cross_for_viewcard"
                    className="cross_for_viewcard"
                    onClick={handleClose}
                  />
                </div>
                <div className="mt-2">
                  {cardList?.map((row) => {
                    return (
                      <div className="d-flex p-2 w-100 bg-white mb-2 card_box">
                        <div>
                          <img
                            src={row?.brand === "visa" ? Visa : Master}
                            alt={row?.brand === "visa" ? "Visa" : "Master"}
                          />
                        </div>
                        <div>
                          <h6>Card No: {row?.cardNo}</h6>
                          <span>Exp Date:: {row?.expDate}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserManagement;
